import apiClient from '../connections/api'

export const guardarSesion = (data) => {
    return apiClient.post('/sessions/guardarSesion', data)
}

export const listaDispositivos = () => {
    return apiClient.get('/sessions/listaDispositivos')
}
